export const educationData = [
    {
        id: 1,
        institution: 'Al-Amyn Model School Gulmit',
        course: 'Secondary Education',
        startYear: '2007',
        endYear: '2017'
    },
    {
        id: 2,
        institution: 'Elysian Higher Secondary School & College',
        course: 'Pre-Engineering',
        startYear: '2017',
        endYear: '2019'
    },
    {
        id: 3,
        institution: 'SZABIST University, Islamabad',
        course: 'Bachelor of Computer Science',
        startYear: '2020',
        endYear: '2024'
    },
]